import { MusicVideoEditor } from '../components/MusicVideoEditor';

export default function MusicVideosPage() {
  return <MusicVideoEditor />;
}
